import { Modal, Button, Form } from 'react-bootstrap'
import CalcomInline from './CalcomInline'

export default function CalcomModal({ show, close, data }) {
  return (
    <Modal
      show={show}
      onHide={close}
      backdrop={'static'}
      size="xl"
    >
      <Modal.Header>
        <Modal.Title>Reschedule Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          width: 'auto',
          height: 'auto',
        }}
      >
        <CalcomInline data={data} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={close}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
